import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Header.module.css";

const Header = ({ user, onLogout, toggleSidebar, onLoginClick }) => {
    const navigate = useNavigate();

    // Intelligently find the user's display name from the object (handles name, username, or email)
    const displayName = user?.name || user?.username || user?.email || "User";
    const initial = displayName.charAt(0).toUpperCase();

    return (
        <header className={classes.header}>
            <div className={classes.leftSection}>
                {user && (
                    <button className={classes.menuBtn} onClick={toggleSidebar}>
                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </button>
                )}
                
                <div 
                    className={classes.logoContainer} 
                    onClick={() => navigate("/")}
                >
                    <div className={classes.logoText}>
                        CHITRA <span className={classes.logoSubtitle}>Slidegen</span>
                    </div>
                </div>
            </div>

            <div className={classes.userSection}>
                {user ? (
                    <>
                        <div className={classes.userInfo}>
                            <div className={classes.avatar}>
                                {initial}
                            </div>
                            <span className={classes.userName}>
                                {displayName}
                            </span>
                        </div>
                        <button 
                            onClick={onLogout}
                            className={classes.logoutBtn}
                        >
                            Log Out
                        </button>
                    </>
                ) : (
                    <button 
                        onClick={onLoginClick}
                        className={classes.loginBtn}
                    >
                        Log In
                    </button>
                )}
            </div>
        </header>
    );
};

export default Header;